<template>
  <div
    class="card shadow-sm border-0 h-100 membresia-card"
    @click="$emit('ver-detalle', { membresia, tipo })"
  >
    <div class="card-header bg-white border-0 pb-0">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <h6 class="mb-1 font-weight-bold">
            {{ membresia.descripcionPlan || 'Sin descripción' }}
          </h6>
          <small class="text-muted">
            {{ membresia.nombreFamilia }} · {{ membresia.nombreSubFamilia }}
          </small>
        </div>
        <span class="badge" :class="estadoBadgeClass">{{ estadoGlosa }}</span>
      </div>
    </div>
    <div class="card-body pt-3">
      <div class="row mb-2">
        <div class="col-6">
          <small class="text-muted d-block">Valor</small>
          <strong>{{ valorPlanFmt }}</strong>
        </div>
        <div class="col-6">
          <small class="text-muted d-block">Duración</small>
          <strong>{{ duracionLabel }}</strong>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <small class="text-muted d-block">Convenio</small>
          <strong>{{ convenioGlosa }}</strong>
        </div>
        <div class="col-6">
          <small class="text-muted d-block">Asignada</small>
          <strong>{{ fechaAsignacionFmt }}</strong>
        </div>
      </div>
      <div class="mb-2">
        <small class="text-muted d-block">Vencimiento</small>
        <strong>{{ fechaVencimientoFmt }}</strong>
      </div>
      <div class="mb-2" v-if="membresia.nombreSucursalAsignacion">
        <small class="text-muted d-block">Sucursal asignación</small>
        <strong>{{ membresia.nombreSucursalAsignacion }}</strong>
      </div>
      <div class="mt-3">
        <small class="text-muted d-block mb-2">
          <i class="fa fa-calendar-o mr-1"></i>
          Turno: {{ (membresia.turno && membresia.turno.descripcionTurno) || '—' }}
        </small>
        <div class="d-flex justify-content-between align-items-center">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click.stop="$emit('eliminar', { membresia, tipo })"
            title="Eliminar membresía"
          >
            <i class="fa fa-trash mr-1"></i>
            Eliminar
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click.stop="$emit('ver-detalle', { membresia, tipo })"
          >
            Ver detalle
            <i class="fa fa-chevron-right ml-1"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembresiaCard',
  props: {
    membresia: { type: Object, required: true },
    tipo: { type: String, required: true }
  },
  computed: {
    estadoGlosa() {
      return (this.membresia.estadoPago && this.membresia.estadoPago.glosa) || 'N/A';
    },
    estadoBadgeClass() {
      const map = {
        VIGENTE: 'badge-success',
        PAGADO: 'badge-success',
        PENDIENTE: 'badge-warning',
        CONGELADO: 'badge-info',
        VENCIDO: 'badge-danger',
        CANCELADO: 'badge-dark'
      };
      return map[this.estadoGlosa.toUpperCase()] || 'badge-secondary';
    },
    fechaVencimientoFmt() {
      if (!this.membresia.fechaVencimiento) return '—';
      const d = new Date(this.membresia.fechaVencimiento);
      if (isNaN(d.getTime())) return this.membresia.fechaVencimiento;
      return d.toLocaleDateString('es-CL');
    },
    fechaAsignacionFmt() {
      if (!this.membresia.fechaAsignacion) return '—';
      const d = new Date(this.membresia.fechaAsignacion);
      if (isNaN(d.getTime())) return this.membresia.fechaAsignacion;
      return d.toLocaleDateString('es-CL');
    },
    valorPlanFmt() {
      const v = this.membresia.valorPlan;
      if (v == null) return '—';
      try {
        return new Intl.NumberFormat('es-CL', {
          style: 'currency',
          currency: 'CLP',
          maximumFractionDigits: 0
        }).format(v);
      } catch (e) {
        return `$${v}`;
      }
    },
    convenioGlosa() {
      return (this.membresia.convenio && this.membresia.convenio.glosa) || '—';
    },
    duracionLabel() {
      const unidad = this.membresia.unidadDuracionPlan && this.membresia.unidadDuracionPlan.glosa;
      return `${this.membresia.duracionPlan || 0} ${unidad || ''}`.trim();
    }
  }
};
</script>

<style scoped>
.membresia-card {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.membresia-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
}
.badge {
  font-size: 0.78rem;
  padding: 0.35em 0.6em;
}
</style>
